import AdvanceTable from '../../inmobiliario/gestionarUsuarios/tables/usersTable/AdvanceTable';
import AdvanceTableWrapper from '../../inmobiliario/gestionarUsuarios/tables/usersTable/AdvanceTableWrapper';
import AdvanceTableFooter from '../../inmobiliario/gestionarUsuarios/tables/usersTable/AdvanceTableFooter';
import PropTypes from 'prop-types';

const IntegrationTable = ({ columns, data }) => {
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={10}
    >
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle text-black"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden border-light'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
};

IntegrationTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired
};

export default IntegrationTable;
